import React from 'react';
import roleAssignmentRoutes from './RoleAssignment/RoleAssignmentRoutes';
import roleRoutes from './Roles/RolesRoutes';
import { UserAccessSubmenu } from './UserAccessSubmenu';
import userRoutes from './Users/UsersRoutes';
import { MFASettingsForm } from './MFA/MFASettingsForm';
import { PasswordPolicyForm } from './PasswordPolicy/PasswordPolicyForm';

const userAccessRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/general-setting/user-access`,
		},
		component: <UserAccessSubmenu />,
	},
	...userRoutes,
	...roleRoutes,
	...roleAssignmentRoutes,
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/general-setting/user-access/password-policy`,
		},
		component: <PasswordPolicyForm />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/general-setting/user-access/mfa`,
		},
		component: <MFASettingsForm />,
	},
];

export default userAccessRoutes;
